const $ = window.jQuery;

/**
 * Enables 'MWB Modal' plugin specific scripting
 */
const Modals = {

    /**
     * Initialise functionality
     */
    init()
    {

        let vm = this;

        vm.handleTriggers();

    },

    /**
     * Handle automatically triggered modals
     */
    handleTriggers()
    {

        const vm = this;
        const $body = $('body');
        const currentPath = window.location.pathname;

        $('div[data-modal-id]').each(function() {

            // Get modal details
            const modal = vm.getModal($(this));

            // Skip modals without a trigger type
            if (!modal.trigger.type || modal.trigger.type === 'none') {
                return;
            }

            // Skip modals that don't satisfy the current path
            if (!vm.isMatchingPath(modal.trigger.paths, currentPath)) {
                return;
            }

            // Implement various trigger types
            switch (modal.trigger.type) {
                case 'logged_out':

                    // Skip is user is logged in
                    if ($body.hasClass('logged-in')) {
                        return;
                    }

                    // Start timer after first interaction
                    $body.one('mousemove scroll keydown', () => {
                        vm.triggerModal(modal);
                    });

                    break;
                case 'logged_in':

                    // Skip is user is logged in
                    if (!$body.hasClass('logged-in')) {
                        return;
                    }

                    // Start timer after first interaction
                    $body.one('mousemove scroll keydown', () => {
                        vm.triggerModal(modal);
                    });

                    break;
            }

        });

    },

    /**
     * Get modal with it's trigger settings
     * @param {jQuery element} $modal Modal element
     * @returns Object
     */
    getModal($modal)
    {
        return {
            id: $modal.data('modal-id'),
            $el: $modal,
            trigger: {
                type: $modal.data('modal-trigger-type') || false,
                paths: ($modal.data('modal-trigger-paths') || []).filter(Boolean),
                delay: $modal.data('modal-trigger-delay') || 0,
                limit: parseInt($modal.data('modal-trigger-limit') || 0),
            },
        };
    },

    /**
     * Trigger modal taking into account
     * - possible "trigger limit"
     * - "trigger delay"
     * @param {Object} modal Modal object
     * @returns void
     */
    triggerModal(modal)
    {

        // Check localStorage support
        if (typeof (Storage) === 'undefined') {
            console.error('Modal could not be opened, localStorage API not available');
            return;
        }

        // Possibly prevent trigger based on it's "trigger limit"
        if (modal.trigger.limit > 0) {

            // Check trigger limit has been reached already
            const triggerCount = parseInt(
                localStorage.getItem(`modal-${modal.id}-trigger-count`) || 0);
            if (triggerCount >= modal.trigger.limit) {
                return;
            }

            // Increment trigger count
            localStorage.setItem(`modal-${modal.id}-trigger-count`, triggerCount + 1);

        }

        // Open modal after delay
        setTimeout(() => {
            $('body')[0].dispatchEvent(
                new CustomEvent('modal-change', {detail: modal.id}));
        }, 1000 * modal.trigger.delay);

    },

    /**
     * Whether given trigger paths matches current page
     * @param {array} triggerPaths
     * @param {string} currentPath
     * @return {bool}
     */
    isMatchingPath(triggerPaths, currentPath)
    {

        // Pass if no paths have been provided
        if (!triggerPaths.length) {
            return true;
        }

        // Check any paths directly match
        if (triggerPaths.includes(currentPath)) {
            return true;
        }

        // Test any regex paths matches
        if (triggerPaths.some(triggerPath => {

            // Skip if line isn't regex (they have to start with `\/`)
            if (!triggerPath.startsWith('\\/')) {
                return false;
            }

            // Test regex
            try {
                const regex = new RegExp(triggerPath);
                return regex.test(currentPath);
            } catch (error) {
                console.error('Invalid trigger path for modal');
            }

        })) {
            return true;
        }

        return false;

    },

};

export default Modals;
